const key = `${process.env.VUE_APP_STORAGE_PREFIX}supportSession`;

export function getSupportSession() {
  try {
    const value = JSON.parse(sessionStorage.getItem(key));
    return value && value.token && value.organizationId && value.expiresAt ? value : null;
  } catch (error) {
    return null;
  }
}

export function saveSupportSession(session) {
  sessionStorage.setItem(key, JSON.stringify({
    token: session.token,
    organizationId: session.organizationId,
    expiresAt: session.expiresAt,
  }));
}

export function getSupportToken() {
  const session = getSupportSession();
  return session && session.token;
}

export function getSupportOrganizationId() {
  const session = getSupportSession();
  return session && session.organizationId;
}

export function clearSupportSession() {
  sessionStorage.removeItem(key);
}
